<template>
    <el-form ref="ruleForm" :model="localFormData" :rules="formRules" label-width="100px"
        :label-position="labelPosition" class="demo-ruleForm">
        <el-form-item v-for="item in formItems" :key="item.id" :required="item?.required" :label="item?.label"
            :prop="item.prop">
            <el-input v-if="item.type === 'input'" :placeholder="'请输入' + item.placeholder"
                v-model="localFormData[item.prop]" :show-password="item.isShowPsw"
                @input="updateField(item.prop, $event)"></el-input>
            <el-select v-if="item.type === 'select'" v-model="localFormData[item.prop]"
                :placeholder="'请选择' + item.placeholder">
                <el-option v-for="item1 in item.model" :key="item1[item.propsConfig?.value]"
                    :label="item1[item.propsConfig?.label]" :value="item1[item.propsConfig?.value]" />
            </el-select>
            <div v-if="item.type === 'cs-btn'" class="cancel-confirm flex">
                <el-button @click="resetForm">取 消</el-button>
                <el-button type="primary" @click="submitForm">确 定</el-button>
            </div>
        </el-form-item>
    </el-form>
</template>
<script>
export default {
    props: {
        formData: { type: Object, default: null },
        formItems: { type: Array, default: null },
        formRules: { type: Object, default: null },
        labelPosition: { type: String, default: 'left' },
    },
    data() {
        return {
            localFormData: JSON.parse(JSON.stringify(this.formData))
        };
    },
    watch: {
        formData: {
            handler(newVal) {
                this.localFormData = { ...newVal }; // 同步父组件更新
            },
            deep: true
        }
    },
    mounted() {
        // console.log(this.formData, this.localFormData, 'dddddddddddddd');
    },
    methods: {
        updateField(key, value) {
            // console.log(key, value, 'key, value');
            this.$emit('update:formData', {
                ...this.formData,
                [key]: value
            });
        },
        submitForm() {
            this.$refs.ruleForm?.validate((valid) => {
                if (valid) {
                    this.$emit('submit', this.localFormData);
                } else {
                    // console.log('error submit!!');
                    return false;
                }
            });
        },
        resetForm() {
            this.$refs.ruleForm?.resetFields();
            this.localFormData = {...this.formData}
            this.$emit('handleFormClose');
        },
    }
}
</script>

<style lang="less" scoped>
:deep(.el-form-item) {
    &:last-child {
        margin-bottom: 0;
    }

    .el-select {
        width: 100%;
    }

    .cancel-confirm {
        width: 100%;
        justify-content: end;
    }

    .el-form-item__label {
        text-align: right;
    }
}

:deep(.el-form-item__content) {
    margin: 0 !important;
    display: flex;
}
</style>